<template>
  <section class="pmp-card">
    <div class="pmp-section-head">
      <h1 class="pmp-section-title">Datos de producción</h1>
    </div>

    <div class="pmp-fecha-hora-grid">
      <PMPDateField
        v-model="localForm.fecha"
        id="pmp-fecha-produccion"
        label="Fecha de producción"
        placeholder="DD/MM/AAAA"
        :error="errors.fecha"
        error-message="Captura la fecha en formato día/mes/año."
        @update:modelValue="notifyFieldChange('fecha')"
      />

      <PMPTimeField
        v-model="localForm.hora"
        id="pmp-hora-produccion"
        label="Hora"
        :error="errors.hora"
        error-message="Selecciona la hora en que se hizo la producción."
        @update:modelValue="notifyFieldChange('hora')"
      />
    </div>

    <PMPDropdown
      v-model="localForm.operador"
      label="Operador"
      placeholder="Selecciona operador"
      :options="operadores"
      :error="errors.operador"
      error-message="Selecciona un operador."
      @select="handleOperadorSelect"
    />

    <PMPDropdown
      v-model="localForm.maquina"
      label="Máquina"
      placeholder="Selecciona máquina"
      :options="maquinas"
      :error="errors.maquina"
      error-message="Selecciona una máquina."
      @select="handleMaquinaSelect"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";

import PMPDateField from "../components/PMPDateField.vue";
import PMPTimeField from "../components/PMPTimeField.vue";
import PMPDropdown from "../components/PMPDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  operadores: {
    type: Array,
    default: () => [],
  },
  maquinas: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleOperadorSelect(option) {
  localForm.value.operadorLabel = option.label;
  notifyFieldChange("operador");
}

function handleMaquinaSelect(option) {
  localForm.value.maquinaLabel = option.label;
  notifyFieldChange("maquina");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
